import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthDto } from './auth.dto';
import { AuthModel } from './auth.model';
import { IS_INTERCEPTING_ENABLED } from '../interceptors/http.interceptor';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private http: HttpClient = inject(HttpClient);
  private baseURL = environment.apiUrl;

  login(authModel: AuthModel): Observable<AuthDto> {
    return this.http.post<AuthDto>(`${this.baseURL}/login`, authModel, {
      context: new HttpContext().set(IS_INTERCEPTING_ENABLED, false)
    });
  }

  test(): Observable<AuthDto> {
    return this.http.get<AuthDto>(`${this.baseURL}/test`);
  }

  logout() {
    return this.http.post<AuthDto>(`${this.baseURL}/logout`, null);
  }
}
